import { Routes, Route, useLocation } from "react-router-dom";

import { SwitchAnimation } from "../../Animation/Animation.jsx";

import { CabinetFinance } from "./CabinetFinance/CabinetFinance.jsx";
import { CabinetScheduleStudent } from "./CabinetScheduleStudent/CabinetScheduleStudent.jsx";
import { CabinetScheduleTeacher } from "./CabinetScheduleTeacher/CabinetScheduleTeacher.jsx";

import { CabinetModule } from "./CabinetModule/CabinetModule.jsx";

export const CabinetMainContent = ({ data, activeUser, email }) => {
  const location = useLocation();
  const user = data[activeUser];
  const isStudent = user.role === "Ученик";

  if (isStudent) {
    return (
      <SwitchAnimation keyAnimation={location.key}>
        <div className="mt-3">
          <Routes location={location}>
            <Route
              index
              element={
                <div className="row">
                  <div className="col-md-8 col-lg-6 mx-auto mb-4 mb-lg-0">
                    <CabinetScheduleStudent user={user} />
                  </div>
                  <div className="col-md-8 col-lg-6 mx-auto">
                    <CabinetModule user={user} student />
                  </div>
                </div>
              }
            />
            <Route
              path="finance/"
              element={<CabinetFinance user={user} email={email} />}
            />
          </Routes>
        </div>
      </SwitchAnimation>
    );
  } else {
    return (
      <SwitchAnimation keyAnimation={location.key}>
        <div className="mt-3">
          <Routes location={location}>
            <Route
              index
              element={
                <div className="row">
                  <div className="col-12 mx-auto mb-3">
                    <CabinetScheduleTeacher user={user} />
                  </div>
                  <div className="col-md-8 mx-auto">
                    <CabinetModule user={user} />
                  </div>
                </div>
              }
            />
            <Route
              path="finance/"
              element={<CabinetFinance user={user} email={email} />}
            />
          </Routes>
        </div>
      </SwitchAnimation>
    );
  }
};
